import { Controller } from "@hotwired/stimulus"
import controller from "../../../utils/controller"

export default class extends Controller {
  static targets = ["building", "unit"]

  connect() {
    // wait for selectize to initialize
    setTimeout(() => this.update())
  }

  update(event) {
    if (!this.hasUnitTarget || this.buildingTarget.hasAttribute("readonly")) return

    if (this.buildingTarget.value === "") {
      this.unitSelect.disable()
    } else {
      if (event) { // changed
        this.unitSelect.enable()
        this.unitSelect.clearOptions()
      }

      const url = new URL(this.unitTarget.dataset.selectWithSearchUrlValue, window.location.origin)
      url.searchParams.set("building_id", this.buildingTarget.value)
      this.unitTarget.dataset.selectWithSearchUrlValue = url.toString()
    }
  }

  get unitSelect() {
    return controller(this.unitTarget, "select-with-search")
  }
}
